export default "__VITE_ASSET__CIaPpF0w__"